import { render, staticRenderFns } from "./procedure.vue?vue&type=template&id=6dba6bcc"
import script from "./procedure.vue?vue&type=script&lang=ts"
export * from "./procedure.vue?vue&type=script&lang=ts"
import style0 from "./procedure.vue?vue&type=style&index=0&id=6dba6bcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports